import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import SolutionsPage from './pages/SolutionsPage';
import Industries from './pages/Industries';
import NotFoundPage from './pages/NotFoundPage';
import HealthcareAIPage from './pages/HealthcareAIPage';
import LidarServicesPage from './pages/LidarServicesPage';
import CloudSolutionsPage from './pages/CloudSolutionsPage';
import SoftwareDevelopmentPage from './pages/SoftwareDevelopmentPage';
import RoboticsPage from './pages/RoboticsPage';
import AiDevelopmentPage from './pages/AiDevelopmentPage';

function App() {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-figma-dark-bg-primary text-figma-dark-text-primary">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/industries" element={<Industries />} />
          
          {/* Service Pages */}
          <Route path="/healthcare-ai" element={<HealthcareAIPage />} />
          <Route path="/lidar-services" element={<LidarServicesPage />} />
          <Route path="/cloud-solutions" element={<CloudSolutionsPage />} />
          <Route path="/software-development" element={<SoftwareDevelopmentPage />} />
          <Route path="/robotics" element={<RoboticsPage />} />
          <Route path="/ai-development" element={<AiDevelopmentPage />} />
          
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App; 